import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../../store/store';
import {
  PROFILE_CHANGE_EMAIL,
  PROFILE_CHANGE_PASSWORD,
  PROFILE_CHANGE_PHONE,
  TOKENS_INDEX,
} from '../../router/routes';
import Form from '../../components/form';
import Disabled from '../../components/form/elements/disabled';
import Text from '../../components/form/elements/text';
import Group from '../../components/form/elements/group';
import HtmlBlock from '../../components/form/elements/html-block';
import css from './index.module.css';

export default function InitialProfileForm() {
  const history = useHistory();
  const { t } = useTranslation();
  const { user } = useSelector((state: RootState) => ({
    user: state.global.user,
  }));

  const openEmailLink = (
    <div
      data-name="change-email"
      className={`${css['action-link']}  pt-4`}
      onClick={() => history.push(PROFILE_CHANGE_EMAIL)}
    >
      <span>{t('pages.profile.buttons.change_email')}</span>
    </div>
  );

  const openPhoneLink = (
    <div
      data-name="change-phone"
      className={`${css['action-link']}`}
      onClick={() => history.push(PROFILE_CHANGE_PHONE)}
    >
      <span>{t('pages.profile.buttons.change_phone')}</span>
    </div>
  );

  const openPasswordLink = (
    <div
      data-name="change-password"
      className={`${css['action-link']}`}
      onClick={() => history.push(PROFILE_CHANGE_PASSWORD)}
    >
      <span>
        {user.hasPassword
          ? t('pages.profile.buttons.change_password')
          : t('pages.profile.buttons.set_password')}
      </span>
    </div>
  );
  const openTokenLink = (
    <div
      data-name="change-password"
      className={`${css['action-link']}`}
      onClick={() => history.push(TOKENS_INDEX)}
    >
      <span>{t('pages.profile.buttons.tokens')}</span>
    </div>
  );

  const [bodyElements] = useState(() => [
    Group([
      Disabled([
        Text('name'),
        Text('email'),
        Text('phone', t('pages.profile.fields.phone')),
      ]),
      HtmlBlock(null, openEmailLink),
      HtmlBlock(null, openPhoneLink),
      HtmlBlock(null, openPasswordLink),
      HtmlBlock(null, openTokenLink),
    ]),
  ]);

  return (
    <Form
      mode={'create'}
      title={t('pages.profile.title')}
      backTo={null}
      body={bodyElements}
      footer={null}
      values={user}
      submit={null}
      schema={null}
    />
  );
}
